import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdKeyboardArrowRight } from "react-icons/md";
import SummaryApi from '../../common';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Import the toastify CSS


const StuAdmissionForm = () => {
    const [formData, setFormData] = useState({
        studentId: '',
        studentCode: '',
        firstName: '',
        lastName: '',
        gender: '',
        fatherName: '',
        motherName: '',
        dob: '',
        religion: '',
        fatherOccupation: '',
        aadharNumber: '',
        email: '',
        mobileNumber: '',
        parentMobileNumber: '',
        admissionDate: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        nationality: '',
        bloodGroup: '',
        studentImage: null, // Updated for image handling
        isActive: true, // Updated to handle checkbox state
        password: '', // Added password field
    });

    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        if (type === "checkbox") {
            setFormData({
                ...formData,
                [name]: checked,
            });
        } else if (type === "file") {
            setFormData({
                ...formData,
                [name]: files[0], // For file inputs, only the first file is taken
            });
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        const studentData = {
            first_name: formData.firstName,
            last_name: formData.lastName,
            gender: formData.gender,
            father_name: formData.fatherName,
            mother_name: formData.motherName,
            dob: formData.dob,
            religion: formData.religion,
            father_occupation: formData.fatherOccupation,
            aadhar_number: formData.aadharNumber,
            email: formData.email,
            mobile_number: formData.mobileNumber,
            parent_mobile_number: formData.parentMobileNumber,
            admission_date: formData.admissionDate,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            pincode: formData.pincode,
            nationality: formData.nationality,
            blood_group: formData.bloodGroup,
            student_image: formData.studentImage, // For the image
            password: formData.password, // Include the password
            is_active: formData.isActive ? '1' : '0', // Map the checkbox value to '1' or '0'
        };
    
        try {
            const formDataObj = new FormData();
            for (const key in studentData) {
                formDataObj.append(key, studentData[key]);
            }
    
            const response = await fetch(SummaryApi.createStudent.url, {
                method: 'POST',
                body: formDataObj, // Use FormData for file uploads
            });
    
            const data = await response.json();
    
            if (response.ok) {
                console.log('Student created successfully', data);
                toast.success('Student created successfully!');  // Display success toast
                handleReset();  // Clear all form fields
            } else {
                console.error('Error:', data.message);
                if (data.message === 'Aadhar number already exists.') {
                    setError("This Aadhar number already exists. Please enter a different one.");
                }
            }
        } catch (error) {
            console.error('Network error:', error);
            toast.error('Network error. Please try again!');  // Display error toast
        }
    };
    

    const handleReset = () => {
        setFormData({
            studentId: '',
            studentCode: '',
            firstName: '',
            lastName: '',
            gender: '',
            fatherName: '',
            motherName: '',
            dob: '',
            religion: '',
            fatherOccupation: '',
            aadharNumber: '',
            email: '',
            mobileNumber: '',
            parentMobileNumber: '',
            admissionDate: '',
            address: '',
            city: '',
            state: '',
            pincode: '',
            nationality: '',
            bloodGroup: '',
            studentImage: null,
            isActive: true,
            password: '', // Reset password
        });
        setError(''); // Reset error message
    };

    return (
        <div className="p-6">
            <h1 className="text-2xl font-semibold mb-3">Students</h1>

            {/* Breadcrumb Navigation */}
            <nav className="text-gray-600 mb-4">
                <ol className="flex space-x-2 text-[16px]">
                    <li>
                        <Link to="/dashboard" className="hover:text-[#ffa404]">
                            Home
                        </Link>
                    </li>
                    <li className="text-[#ffa404]">
                        <MdKeyboardArrowRight size={25} />
                    </li>
                    <li className="text-[#ffa404]">
                        <Link to="/allStudents" className="hover:text-[#ffa404]">
                            Student Admit Form
                        </Link>
                    </li>
                </ol>
            </nav>

            {/* Card Container */}
            <div className="bg-white shadow-md rounded-lg p-6 mt-6 h-auto">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Add New Students</h2>

                <form onSubmit={handleSubmit} className="space-y-4">
                    {/* Form fields */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                        {/* First Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">First Name*</label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Last Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Last Name*</label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Gender */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Gender*</label>
                            <select
                                name="gender"
                                value={formData.gender}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            >
                                <option value="">Select Gender</option>
                                <option value="male">Male</option>
                                <option value="female">Female</option>
                                <option value="other">Other</option>
                            </select>
                        </div>

                        {/* Father Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Father Name*</label>
                            <input
                                type="text"
                                name="fatherName"
                                value={formData.fatherName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Mother Name */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Mother Name*</label>
                            <input
                                type="text"
                                name="motherName"
                                value={formData.motherName}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Date of Birth */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Date of Birth*</label>
                            <input
                                type="date"
                                name="dob"
                                value={formData.dob}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Religion */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Religion*</label>
                            <input
                                type="text"
                                name="religion"
                                value={formData.religion}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                        {/* Email */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">E-Mail*</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Mobile Number */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Mobile Number*</label>
                            <input
                                type="text"
                                name="mobileNumber"
                                value={formData.mobileNumber}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Parent Mobile Number */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Parent Mobile Number*</label>
                            <input
                                type="text"
                                name="parentMobileNumber"
                                value={formData.parentMobileNumber}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                        {/* Aadhar Number */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Aadhar Number*</label>
                            <input
                                type="text"
                                name="aadharNumber"
                                value={formData.aadharNumber}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Blood Group */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Blood Group*</label>
                            <input
                                type="text"
                                name="bloodGroup"
                                value={formData.bloodGroup}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>
                         {/* Father's Occupation */}
                         {/* <div>
                            <label className="block text-[16px] font-medium text-gray-500">Father's Occupation*</label>
                            <input
                                type="text"
                                name="fatherOccupation"
                                value={formData.fatherOccupation}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div> */}

                        {/* Admission Date */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Admission Date*</label>
                            <input
                                type="date"
                                name="admissionDate"
                                value={formData.admissionDate}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                        {/* Address */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Address*</label>
                            <input
                                type="text"
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* City */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">City*</label>
                            <input
                                type="text"
                                name="city"
                                value={formData.city}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* State */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">State*</label>
                            <input
                                type="text"
                                name="state"
                                value={formData.state}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Pincode */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Pincode*</label>
                            <input
                                type="text"
                                name="pincode"
                                value={formData.pincode}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>

                        {/* Nationality */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Nationality*</label>
                            <input
                                type="text"
                                name="nationality"
                                value={formData.nationality}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                        {/* Image Upload */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Student Image*</label>
                            <input
                                type="file"
                                name="studentImage"
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                        </div>

                        {/* Password */}
                        <div>
                            <label className="block text-[16px] font-medium text-gray-500">Password*</label>
                            <input
                                type="password"
                                name="password"
                                value={formData.password}
                                onChange={handleChange}
                                className="mt-1 p-3 w-full bg-gray-100 rounded-md focus:ring-[#ffa404]"
                                required
                            />
                        </div>
                        {/* Active Status */}
                        <div className='flex'>
                        <input
                                type="checkbox"
                                name="isActive"
                                checked={formData.isActive}
                                onChange={handleChange}
                                className="mr-2 p-3 bg-gray-100 rounded-md focus:ring-[#ffa404]"
                            />
                            <label className="block text-[16px] font-medium text-gray-500">Is Active</label>
                           
                        </div>

                    </div>

                    {error && <div className="text-red-500 mt-2">{error}</div>}

                    <div className="flex space-x-4 mt-4">
                        <button
                            type="submit"
                            className="p-4 bg-[#ffa404] text-white rounded-md hover:bg-[#e89d02] flex items-center justify-center"
                        >
                            Save
                        </button>
                        <button
                            type="button"
                            onClick={handleReset}
                            className="p-4 bg-gray-300 text-black rounded-md hover:bg-gray-400 flex items-center justify-center"
                        >
                            Reset
                        </button>
                    </div>
                </form>
                <ToastContainer />
            </div>
        </div>
    );
};

export default StuAdmissionForm;
